export class Build {
  public static calc(str: number, siz: number) {
    const val = str + siz;
    if (val <= 64 && val >= 2) {
      return -2;
    } else if (val <= 84 && val >= 65) {
      return -1;
    } else if (val <= 124 && val >= 85) {
      return 0;
    } else if (val <= 164 && val >= 125) {
      return 1;
    } else if (val <= 204 && val >= 165) {
      return 2;
    } else if (val <= 284 && val >= 205) {
      return 3;
    } else if (val <= 364 && val >= 285) {
      return 4;
    } else if (val <= 444 && val >= 365) {
      return 5;
    } else if (val <= 524 && val >= 445) {
      return 6;
    } else {
      return 0;
    }
  }
}
